/* eslint-disable fabric-ui/no-let */
/* eslint-disable no-continue */

import { normalizeFacet } from './normalize-facet';

type JSONPrimitive = string | number | boolean | null | undefined | bigint;

const isPlainObject = (v: unknown): v is Record<string, unknown> => {
  if (v === null || typeof v !== 'object') return false;
  const p = Object.getPrototypeOf(v);
  return p === Object.prototype || p === null;
};

const joinObj = (base: string, seg: string) => (base ? `${base}.${seg}` : seg);
const joinArr = (base: string, idx: number) => `${base}[${idx}]`;

export const flattenDocument = (input: object): Record<string, JSONPrimitive> => {
  if (input === null || typeof input !== 'object' || (!Array.isArray(input) && !isPlainObject(input)))
    throw new Error('flattenDocument: root must be a JSON-like object or array');

  const out: Record<string, JSONPrimitive> = {};
  const seen = new WeakSet<object>();

  type StackItem = { value: unknown; path: string };
  const stack: StackItem[] = [{ value: input, path: '' }];

  while (stack.length > 0) {
    const { value, path } = stack.pop()!;

    if (value === null || typeof value !== 'object') {
      if (path) out[path] = value as JSONPrimitive;

      continue;
    }

    if (seen.has(value)) throw new Error('flattenDocument: circular reference detected');
    seen.add(value);

    if (Array.isArray(value)) {
      if (value.length === 0) {
        if (path) out[path] = null;
        continue;
      }
      for (let i = value.length - 1; i >= 0; i--) stack.push({ value: value[i], path: joinArr(path, i) });

      continue;
    }

    if (isPlainObject(value)) {
      const keys = Object.keys(value);
      if (keys.length === 0) {
        if (path) out[path] = null;
        continue;
      }

      for (let i = keys.length - 1; i >= 0; i--) {
        const k = keys[i];
        stack.push({
          value: value[k],
          path: joinObj(path, normalizeFacet(k)),
        });
      }

      continue;
    }
  }

  return out;
};
